

document.addEventListener( 'DOMContentLoaded', () => {

	const isWheelPage = document.querySelector( '[data-word-button]' )
	const livingWellCarousel = document.querySelector( '.living-well-carousel' );

	if ( isWheelPage && livingWellCarousel ) {

		const innerButtons = document.querySelector( '#inner-buttons' );
		const dimensionsOfWellness = document.querySelector( '#dimensions-of-wellness' );
		const wordButtons = document.querySelectorAll( '[data-word-button]' )
		const showExpandedWords = document.querySelectorAll( '[data-view-expanded="true"]' );
		const hideExpandedWords = document.querySelectorAll( '[data-view-expanded="false"]' );

		const prevButton = document.querySelector( '[data-previous-slide]' );
		const nextButton = document.querySelector( '[data-next-slide]' );
		const allSlides = document.querySelectorAll( '[data-slide]' )
		const hideSlider = document.querySelector( '[data-hide-slider]' );

		const handleSlideChange = ( wordButton ) => {
			if ( livingWellCarousel.classList.contains( 'dn' ) ) {
				livingWellCarousel.classList.remove( 'dn' )
			}
			if ( hideSlider.classList.contains( 'dn' ) ) {
				hideSlider.classList.remove( 'dn' )
			}
			if ( ! dimensionsOfWellness.classList.contains( 'dn' ) ) {
				dimensionsOfWellness.classList.add( 'dn' )
			}
			hideExpandedWords.forEach( word => {
				word.style.display = 'block'
			} )
			showExpandedWords.forEach( word => {
				word.style.display = 'none'
			} )
			const word = wordButton.dataset.wordButton
			const slide = document.querySelector( `[data-slide="${word}"]` )
			livingWellCarousel.dataset.currentSlide = word;
			allSlides.forEach( singleSlide => {
				singleSlide.style.position = 'absolute'
				singleSlide.style.opacity = '0'
				singleSlide.classList.remove( 'absolute' )
				singleSlide.classList.remove( 'o-0' )
				singleSlide.classList.remove( 'relative' )
			} )
			slide.style.position = 'relative'
			slide.style.opacity = '1'
			innerButtons.style.transform = `rotate(-${wordButton.dataset.rotate}deg)`
		}

		wordButtons.forEach( wordButton => wordButton.addEventListener( 'click', () => {
			handleSlideChange( wordButton )
			wordButtons.forEach( innerWordButton => { innerWordButton.style.opacity = '0.25' } )
			wordButton.style.opacity = '1';
			if ( wordButton.dataset.wordButton === 'Emotional' ) wordButton.dataset.rotate = '0'
		} ) )

		hideSlider.addEventListener( 'click', () => {
			if ( ! livingWellCarousel.classList.contains( 'dn' ) ) {
				livingWellCarousel.classList.add( 'dn' )
			}
			hideExpandedWords.forEach( word => {
				word.style.display = 'none'
			} )
			showExpandedWords.forEach( word => {
				word.style.display = 'block'
			} )
			hideSlider.classList.add( 'dn' )
			dimensionsOfWellness.classList.remove( 'dn' )
			innerButtons.style.transform = 'rotate(0deg)'
			wordButtons.forEach( innerWordButton => { innerWordButton.style.opacity = '1' } )
		} )

		const changeSlide = ( slide ) => {
			const previousSlideWord = slide.dataset.slide;
			const wordButton = document.querySelector( `[data-word-button="${previousSlideWord}"]` )
			handleSlideChange( wordButton )
			wordButton.style.opacity = '1';
		}

		const handleSlide = ( button, max, plus, newIndex ) => {
			wordButtons.forEach( innerWordButton => { innerWordButton.style.opacity = '0.25' } )
			const currentSlideElement = document.querySelector( '[data-current-slide]' );
			const {currentSlide} = currentSlideElement.dataset
			const currentSlideIndex = document.querySelector( `[data-slide="${currentSlide}"]` ).dataset.slideIndex
			if ( Number( currentSlideIndex ) !== max ) {
				const previousSlide = plus === 'add' ? document.querySelector( `[data-slide-index="${Number( currentSlideIndex ) + 1}"]` ) : document.querySelector( `[data-slide-index="${Number( currentSlideIndex ) - 1}"]` )
				changeSlide( previousSlide )
			} else {
				const previousSlide = allSlides[newIndex]
				changeSlide( previousSlide )
			}
		}


		prevButton.addEventListener( 'click', () => handleSlide( prevButton, 0, 'minus', allSlides.length - 1 ) )
		nextButton.addEventListener( 'click', () => handleSlide( nextButton, allSlides.length - 1, 'add', 0 ) )

	}
} )
